/* global jQuery */
jQuery( document ).ready( function() {
	const $document = jQuery( document );
	const $menuToggle = jQuery( '#menu-toggle' );
	const $menuOverlay = jQuery( '#overlay-menu' );
	const $menuClose = jQuery( '.overlay__close' );

	const $modalTabbables = jQuery( '#overlay-menu a, #overlay-menu .overlay__close' );
	const $firstModalTabbable = $modalTabbables.first();
	const $lastModalTabbable = $modalTabbables.last();

	const closeModal = () => {
		$menuOverlay.removeClass( 'open' );
		$menuOverlay.attr( 'aria-hidden', 'true' );
		$menuToggle.attr( 'aria-expanded', 'false' );
	};

	const openModal = () => {
		$menuOverlay.addClass( 'open' );
		$menuOverlay.attr( 'aria-hidden', 'false' );
		$menuToggle.attr( 'aria-expanded', 'true' );
	};

	// Open and close menu
	$menuToggle.click( () => {
		if ( $menuOverlay.hasClass( 'open' ) ) {
			closeModal();
		} else {
			openModal();
		}
	} );

	// Close modal on backdrop click
	$menuOverlay.on( 'click', ( e ) => {
		if ( e.target !== this && ! jQuery( e.target ).hasClass( 'container__medium' ) ) {
			return;
		}

		closeModal();
	} );

	// Close modal on close button click
	$menuClose.click( () => {
		closeModal();
	} );

	// Close menu on escape key press
	$document.on( 'keydown', function( event ) {
		if ( event.key === 'Escape' && $menuOverlay.hasClass( 'open' ) ) {
			closeModal();
		}
	} );

	// Trap focus inside modal
	// Redirect last tabbable item
	$lastModalTabbable.on( 'keydown', ( e ) => {
		if ( ( e.which === 9 && ! e.shiftKey ) ) {
			e.preventDefault();
			$firstModalTabbable.focus();
		}
	} );

	// Redirect first tabble
	$firstModalTabbable.on( 'keydown', ( e ) => {
		if ( ( e.which === 9 && e.shiftKey ) ) {
			e.preventDefault();
			$lastModalTabbable.focus();
		}
	} );

	// Homepage scroll down
	const $scrollButton = jQuery( '.home__scroll-button' );
	const $gutenbergContent = jQuery( '.gutenberg-content' );

	$scrollButton.click( ( e ) => {
		e.preventDefault();

		$gutenbergContent[ 0 ].scrollIntoView( {
			behavior: 'smooth',
		} );
	} );

	// Accordions
	const $accordionTitle = jQuery( '.block__accordion-title' );

	$accordionTitle.click( function() {
		const $this = jQuery( this );
		const $panel = jQuery( `#${ $this.attr( 'aria-controls' ) }` );

		if ( $this.hasClass( 'is-expanded' ) ) {
			$this.removeClass( 'is-expanded' );
			$this.attr( 'aria-selected', 'true' );
			$this.attr( 'aria-expanded', 'true' );
			$panel.attr( 'aria-hidden', 'false' );
			$panel.slideToggle();
		} else {
			$this.addClass( 'is-expanded' );
			$this.attr( 'aria-selected', 'false' );
			$this.attr( 'aria-expanded', 'false' );
			$panel.attr( 'aria-hidden', 'true' );
			$panel.slideToggle();
		}
	} );
} );
